import { Fragment, useState, useEffect } from 'react';
import { Button } from '@upmc/ims.component-library';

import axiosInstance from '../../../services/axios/axios';
import { useDispatch } from 'react-redux';
import { addMessage, clearMessages } from '../../../store/ancillary/actions';
import { TextboxTypes, ValidationTextbox } from '../../../components/UI/Input';
import Card, {
	Actions,
	ActionButtons,
} from '../../../components/UI/MDC/Card/Card';
import { SubmitButton } from '../../../components/UI/Input/Button/index';
import {
	Headline4,
	Headline6,
	Subtitle2,
} from '../../../components/UI/MDC/Typography/Typography';
import WithLoadingHandler from '../../../hoc/withLoadingHandler/withLoadingHandler';
import Confirm from '../../../components/AppCart/GenericApps/Confirm/Confirm';
import StyleAuxiliary from '../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import { CSS_CLASSES } from './_constants';

import classes from './Request.module.scss';
import classes_UAR from '../../UserAccessReview/UserAccessReview.module.scss';
import { WrapImsPacket, getSession } from '../../../store/utility';

const Request = props => {
	const dispatch = useDispatch();

	//  Set date for control
	const today = new Date();
	const future = new Date();
	future.setDate(today.getDate() + 14);
	let setDateParts =
		('0' + future.getDate()).slice(-2) +
		'/' +
		('0' + (future.getMonth() + 1)).slice(-2) +
		'/' +
		future.getFullYear();
	let t = setDateParts.split('/');
	let setAssembledDate = t[2] + '-' + t[1] + '-' + t[0];
	//displayDate.getDate('MM-DD-YYYY');
	//  Functional component.  Using hooks rather than Redux since it doesn't seem needed.  Additionally, storing the name and the exp date
	//  may be overkill since they never change and I could directly assign them to the page but it isn't really any extra work.
	const [useEventID, setUseEventID] = useState(null);
	const [useName, setUseName] = useState(null); //  Store User Name
	const [useExpDate, setUseExpDate] = useState(null); //  Store Expiration Date
	const [useRequestDate, setRequestDate] = useState(setAssembledDate); //  Store Selected Date
	const [useLoading, setUseLoading] = useState(true);
	const [useEsoID, setUseEsoID] = useState(null);

	const [useShowLayout, setUseShowLayout] = useState('loading');

	//const SUCCESSMESSAGE =
	//	'Request Successful.  You may now close your browser';

	//  Functional equivalent of componentDidMount
	useEffect(() => {
		//  Need to get the screen info based on the passed eventID by calling the backend
		var qstringList = props.querystring.split('=');
		var eventID = qstringList[1];
		setUseEventID(eventID);
		let esoID;
		getSession('LoggedOnUserESO').then(loggedonUserEso => {
			esoID = loggedonUserEso;
			setUseEsoID(esoID);

			//  axiosInstance is a wrapper around axios.get to keep the token info with the call and prevent us from having to
			//  call it again.

			let payload = {
				EventID: eventID,
				UserID: esoID,
			};

			axiosInstance
				.post(
					'api/ComputerAdminRightsExpRequest/GetRequestInfo',
					WrapImsPacket(payload)
				)
				.then(response => {
					if (response.status === 200) {
						if (response.data.messages.length === 0) {
							setUseName(response.data.payload.Name);
							setUseExpDate(response.data.payload.EndDate);
							setUseLoading(false);
							setUseShowLayout('input');
						} else {
							dispatch(clearMessages());
							dispatch(
								addMessage({
									Key: response.data.messages[0].Key,
									Value: response.data.messages[0].Value,
								})
							);
							setUseLoading(false);
							setUseShowLayout('failure');
						}
					} else {
						//  failed for some reason
						dispatch(clearMessages());
						dispatch(
							addMessage({
								Key: response.data.messages[0].Key,
								Value: response.data.messages[0].Value,
							})
						);
					}
				})
				.catch(error => {
					dispatch(clearMessages());
					dispatch(
						addMessage({
							Key: error.messages[0].Key,
							Value: error.messages[0].Value,
						})
					);
					setUseShowLayout('failure');
				});
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//  validate Data
	const isValidDate = () => {
		let tempString = Date.parse(useRequestDate); //  get request data from stae

		//  Is the date entered a valid data
		var d = new Date(tempString);
		if (Object.prototype.toString.call(d) === '[object Date]') {
			if (isNaN(d.getTime())) {
				dispatch(
					addMessage({
						Key: 3,
						Value: 'Invalid Date.',
					})
				);
				setUseLoading(false);
				return false;
			}
		} else {
			dispatch(
				addMessage({
					Key: 3,
					Value: 'Invalid Date.',
				})
			);
			setUseLoading(false);
			return false;
		}

		//  Is the date entered a current or future data
		var currentDate = new Date();
		if (tempString < currentDate) {
			dispatch(
				addMessage({
					Key: 3,
					Value: 'Selected date cannot be less than current date.',
				})
			);
			setUseLoading(false);
			return false;
		}

		//  Adding 183 days to represent 6 months from today.  That way if we roll over a year or add 6 months and get Feb 30 there is no date error
		var futureDate = new Date();
		futureDate.setDate(futureDate.getDate() + 183);

		if (tempString > futureDate) {
			dispatch(
				addMessage({
					Key: 3,
					Value: 'Input must not exceed 6 months in future.',
				})
			);
			setUseLoading(false);
			return false;
		}

		return true;
	};

	//  Submit to back end

	const submitDate = event => {
		setUseLoading(true);
		dispatch(clearMessages());

		let passString = useRequestDate;
		let dateparts = passString.split('-');
		let assembledDate =
			dateparts[1] + '-' + dateparts[2] + '-' + dateparts[0];

		//  Apply screen side validations
		if (isValidDate()) {
			//  create payload for call (may need to format the date better)
			let payload = {
				EventID: useEventID,
				ExpirationDate: assembledDate,
				UserID: useEsoID,
			};

			//  Call the update
			axiosInstance
				.post(
					'api/ComputerAdminRightsExpRequest/',
					WrapImsPacket(payload)
				)
				.then(response => {
					if (response.status === 200) {
						if (response.data.status === true) {
							setUseShowLayout('success');
						} else {
							setUseShowLayout('failure');
							dispatch(clearMessages());
							dispatch(
								addMessage({
									Key: response.data.messages[0].Key,
									Value: response.data.messages[0].Value,
								})
							);
						}
					} else {
						//  failed for some reason
						setUseShowLayout('failure');
						dispatch(clearMessages());
						dispatch(
							addMessage({
								Key: response.data.messages[0].Key,
								Value: response.data.messages[0].Value,
							})
						);
					}
				})
				.catch(error => {
					setUseShowLayout('failure');
					dispatch(clearMessages());
					dispatch(
						addMessage({
							Key: error.messages[0].Key,
							Value: error.messages[0].Value,
						})
					);
				})
				.finally(() => {
					setUseLoading(false);
				});
		}
	};

	const buildScreen = () => {
		switch (useShowLayout) {
			case 'loading':
				return null;
			case 'input':
				return (
					<Fragment>
						<StyleAuxiliary classes={classes[CSS_CLASSES.PROFILE]}>
							<Headline6
								className={classes[CSS_CLASSES.PROFILE_TITLE]}
							>
								{useName ? useName.toUpperCase() : null}
							</Headline6>
							<Subtitle2>Expiration Date: {useExpDate}</Subtitle2>
						</StyleAuxiliary>
						<Headline6>
							New Expiration Date
							<ValidationTextbox
								id={'dtRequestDate'}
								type={TextboxTypes.DATE}
								name={'dtRequestDate'}
								formDetails={{
									validation: {
										touched: setRequestDate !== null,
									},
									settings: { type: TextboxTypes.Date },
								}}
								onChange={e => {
									setRequestDate(e.target.value);
								}}
								className={classes_UAR['edit-input__textbox']}
								value={useRequestDate}
								valid={true} //update to local state variable
								validationMessage={null}
							/>
						</Headline6>
						<Actions className={classes[CSS_CLASSES.ACTIONS]}>
							<ActionButtons>
								<SubmitButton outlined onClick={submitDate}>
									Submit
								</SubmitButton>
							</ActionButtons>
						</Actions>
					</Fragment>
				);
			case 'success':
				return (
					<Fragment>
						<Confirm
							bannerMessage='Renewal successfully submitted.'
							bodyMessage={
								'Your renewal request for ' +
								useName +
								' has been successfully submitted.'
							}
						/>
					</Fragment>
				);
			case 'failure':
				return null;
			default:
				return null;
		}
	};

	return (
		<StyleAuxiliary classes={classes[CSS_CLASSES.CONTAINER]}>
			<Card large>
				<StyleAuxiliary classes={classes[CSS_CLASSES.TITLE_CONTAINER]}>
					<Button sx={{ visibility: 'hidden'}}>
						Help
					</Button>
					<Headline4 className={classes[CSS_CLASSES.TITLE]}>
						Renew Computer Admin Rights
					</Headline4>
					<Button
						sx={{ visibility: 'hidden'}}
						variant='text'
						aria-label='Help'
						color='primary'
						href=''
						rel='noopener noreferrer'
						target='_blank'
						title='Help'
					>
						Help
					</Button>
				</StyleAuxiliary>
				<WithLoadingHandler isLoading={useLoading}>
					{buildScreen()}
				</WithLoadingHandler>
			</Card>
		</StyleAuxiliary>
	);
};

export default Request;
